/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ProductionAccessRequestResponse = zod
	.object({
		message: zod.string().describe('Success message')
	})
	.describe('Production access request response');

export type ProductionAccessRequestResponse = zod.input<typeof ProductionAccessRequestResponse>;
export type ProductionAccessRequestResponseOutput = zod.output<
	typeof ProductionAccessRequestResponse
>;
